import React from 'react'

import { ExampleWrapperSeamless } from '@/layout-components'

import ForgotPassword from '@/housefolios-components/SignIn/ForgotPassword'

import { Grid } from '@mui/material'

export default function ForgotPasswordPage() {
  return (
    <>
      <ExampleWrapperSeamless>
        <Grid
          container
          direction="row"
          sx={{
            justifyContent: "center",
            width: '100%',
            maxWidth: '100%'
          }}>
          <Grid size={12} sx={{ width: '100%', maxWidth: '100%' }}>
            <ForgotPassword />
          </Grid>
        </Grid>
      </ExampleWrapperSeamless>
    </>
  );
}
